import { Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { allCommonImages } from "../Assets/Images/images";
import React, { ReactNode, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { svg } from "../Assets/svg";
import { alias, BUCKET_URL } from "../helpers/utils";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Close from "../Assets/Images/Icons/Close.svg";
import { UserI } from "../Admin/Types/state/user.state";
import { Swiper as SwiperClass } from "swiper";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import { NavLink } from "react-router-dom";
const Logo = allCommonImages.LogoWhite;
// Site Loader
interface SiteLoaderProps {
  text?: string;
}
export const SiteLoader: React.FC<SiteLoaderProps> = ({ text }) => {
  const { pathname } = useLocation();

  if (pathname === "/") {
    return null;
  }

  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        textAlign: "center",
        width: "calc(100% - 1rem)",
      }}
    >
      <div className="Loader">
        <div className="d-block">
          <div className="spinner-border" role="status"></div>
        </div>
      </div>
      <p className="ff" style={{ fontSize: "1rem", lineHeight: "1.1" }}>
        {text !== undefined
          ? text
          : "Please wait a moment while we arrange some things"}
      </p>
    </div>
  );
};

export const BtnLoader: React.FC<any> = ({ color = "#fff" }: any) => {
  return (
    <Spin
      indicator={
        <LoadingOutlined
          style={{
            fontSize: 16,
            color: color,
          }}
          spin
          className="me-2"
        />
      }
    />
  );
};

interface NavigationBarProps {
  menuOpen: boolean;
  setMenuOpen: (value: boolean) => void;
  navigationData: any;
}
export const TableLoader = () => {
  return (
    <div className="loader-container py-5">
      <div className="loader">
        <div className="spinner-border" role="status"></div>
      </div>
    </div>
  );
};

export function prefixZero(e: number) {
  return Number(e) < 10 ? `${e}` : String(e);
}
interface CustomPaginationProps {
  pageId: number;
  countCalculation: number;
  setPageId: (page: number) => void;
  className: string;
  pageCount: number;
  listCount: number;
  limit: number;
  deletedData?: () => any;
}

// Close Icon Image
export const CloseIcon = () => <img src={Close} alt="close" />;

type Image = {
  _id: string;
  image: string;
  thumb: string;
  user: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  is_active: number;
};

type Props = {
  images: Image[];
  defaultImageId: string; // Default image ID for when no images are provided
};

export const ImageGallery: React.FC<Props> = ({ images, defaultImageId }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<any | null>(null);
  const [selectedImageState, setSelectedImageState] = useState<Image | null>(
    null
  );

  // Set the default image based on defaultImageId or use the first image
  const defaultImage =
    images?.length > 0
      ? images.find((image) => image._id === defaultImageId) || images[0]
      : null;
  // Set the default selected image state
  if (!selectedImageState && defaultImage) {
    setSelectedImageState(defaultImage);
  }

  // Handle Thumbnail Click
  const handleThumbnailClick = (image: Image) => {
    setSelectedImageState(image);
  };
  const selectedIndex =
    images?.findIndex((image) => image._id === selectedImageState?._id) + 1 ||
    0;
  return (
    <div>
      {/* Main Swiper */}
      <Swiper
        loop={true}
        spaceBetween={0}
        navigation={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper2 mb-3"
      >
        {selectedImageState ? (
          [selectedImageState].map((image) => (
            <SwiperSlide key={image._id}>
              <div className="mainSliderBox position-relative overflow-hidden rounded-3">
                <img
                  src={`${BUCKET_URL}${image?.image}`}
                  alt="Main Image"
                  className="position-absolute start-0 top-0 w-100 h-100 object-fit-cover"
                />
              </div>
            </SwiperSlide>
          ))
        ) : (
          <SwiperSlide key={"noImageFound"}>
            <div className="mainSliderBox position-relative overflow-hidden rounded-3">
              <img
                src={`${BUCKET_URL}${"public/common/profile.svg"}`}
                alt="Main Image"
                className="position-absolute start-0 top-0 w-100 h-100 object-fit-cover"
              />
            </div>
          </SwiperSlide>
        )}
      </Swiper>

      {/* Thumbnail Swiper */}
      <Swiper
        onSwiper={setThumbsSwiper}
        loop={false}
        spaceBetween={7}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        scrollbar={{
          draggable: true, // Enable draggable scrollbar
          hide: false, // Ensure scrollbar is visible
        }}
        style={{
          overflowX: "auto", // Allow horizontal scrolling
        }}
        className="mySwiper"
      >
        {images?.length > 0 &&
          images.map((image) => (
            <SwiperSlide
              key={image._id}
              onClick={() => handleThumbnailClick(image)}
            >
              <img
                src={`${BUCKET_URL}${image.thumb}`}
                alt="Thumbnail"
                style={{
                  width: "75px",
                  height: "90px",
                  objectFit: "cover",
                  borderRadius: "4px",
                  border:
                    image._id === selectedImageState?._id
                      ? "2px solid #000"
                      : "none", // Highlight selected thumbnail
                }}
              />
            </SwiperSlide>
          ))}
      </Swiper>
      <div style={{ textAlign: "center", marginBottom: "10px" }}>
        {images?.length > 0 && (
          <div>
            Photos {selectedIndex}/{images.length}
          </div>
        )}
      </div>
    </div>
  );
};

interface DashboardFieldIF {
  columnClass: string;
  className: string;
  path: string;
  svg: ReactNode;
  label: string;
  value?: number | string;
  color?: string;
}
export const DashboardField: React.FC<DashboardFieldIF> = ({
  columnClass,
  className,
  path,
  svg,
  label,
  value,
  color,
}) => {
  return (
    <>
      <div className={`col-xl col-md-4 ${columnClass}`}>
        <NavLink
          className="card dash__card border-0 rounded-3 shadow h-100"
          to={path}
        >
          <div className="card-body d-flex flex-column justify-content-between">
            <div className={"d-flex align-items-center mb-2 " + className}>
              {svg}
              <span
                className={"fs-6 fw-semibold " + className}
                style={{ color: color ?? "black" }}
              >
                {label}
              </span>
            </div>
            <h3 className="fw-bolder fs-36 text-black mb-0">{value ?? 0}</h3>
          </div>
        </NavLink>
      </div>
    </>
  );
};

export const renderFormLabel = (label: string, isRequired: boolean = false) => (
  <span className="fw-semibold">
    {label}
    {isRequired && (
      <span style={{ color: "#FF0004", marginLeft: "2px" }}>*</span>
    )}
  </span>
);

export const RedStar = () => <span style={{ color: "#FF0004" }}>*</span>;
